const LOCALES = ['en', 'es']

export default function LanguageSwitcher({ locale, section, page }) {
  return (
    <div className="flex gap-3 items-center text-xs font-mono">
      {LOCALES.map((l, i) => (
        <span key={l} className="flex items-center gap-3">
          {i > 0 && <span className="text-zinc-600">·</span>}
          <a
            href={`/docs/${l}/${section}/${page}`}
            className={
              l === locale
                ? 'text-emerald-400 font-semibold border-b border-emerald-400'
                : 'text-zinc-500 hover:text-zinc-300'
            }
          >
            {l.toUpperCase()}
          </a>
        </span>
      ))}
    </div>
  )
}
